import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import Header from '../../../components/Header';
import CollegeEventsFilterForm from '../../../components/CollegeEventsFilterForm';
import PageTitle from '../../../components/PageTitle';
import messages from '../messages';
import '../styles.css';

export default class CollegeEventsCreateFilterComponent extends React.PureComponent {
  static propTypes = {
    filter: PropTypes.object,
    saving: PropTypes.bool,
    saveError: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  };

  render() {
    const { saving, saveError } = this.props;
    const { filter, onSave, onCancel } = this.props;
    return (
      <div>
        <PageTitle subTitle="Create Filter" title="Events" category="Intersect" />
        <Header styleName="college-filters-edit-form-header" as="h1"><FormattedMessage {...messages.header} /></Header>
        <CollegeEventsFilterForm
          filter={filter}
          saving={saving}
          saveError={saveError}
          onSave={onSave}
          onCancel={onCancel}
        />
      </div>
    );
  }
}
